import "./index.css";
import React, { forwardRef } from "react";

import type { TypeTag } from "../../../hooks/useAllPrograms";

interface TypeGuidelineItemProps extends Pick<TypeTag, "name"> {
  /**
   * @parma count 关联了多少个 tag
   */
  count?: number;
  onClick(): void;
  checked: boolean;
  /**
   * @param hide 是否显示超过阈值行的图标
   */
  hide?: boolean;
  /**
   * @param index 元素所在位置
   */
  index?: number;
}

/**
 * @name Item guideline 单个 item
 */
const Item: React.ForwardRefRenderFunction<
  HTMLLIElement,
  TypeGuidelineItemProps
> = ({ name, hide, count, index, checked, onClick }, ref) => (
  <li
    ref={ref}
    data-name={name}
    onClick={onClick}
    data-index={index}
    style={{ display: hide ? "none" : "flex" }}
    className={`guideline-label ${checked ? "guideline-label-checked" : ""}`}
  >
    <span>{name}</span>
    {typeof count === "number" && (
      <>
        <span>●</span>
        <span>{count}</span>
      </>
    )}
  </li>
);

export default forwardRef(Item);
